import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, type Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import type { FilterGroup } from './models/filters-search.response';
import { FiltersSearchFactory } from './filters-search.factory';
import type { FilterSearch, FilterSearchParams } from './models/filters-search.model';

@Injectable({
  providedIn: 'root',
})
export class FiltersSearchService {
  private readonly http = inject(HttpClient);
  private readonly filtersSearchFactory = inject(FiltersSearchFactory);

  getFilters(params: FilterSearchParams): Observable<FilterSearch[]> {
    const url = `${environment.apiUrl}/records/search/filters`;

    let httpParams = new HttpParams()
      .set('query', params.query)
      .set('filters', params.filters);

    if (params.criteriaFacets) {
      httpParams = httpParams
        .set('facetNames', params.criteriaFacets.facetNames.join(','))
        .set('facetValues', params.criteriaFacets.facetValues.join(','));
    }

    return this.http
      .get<FilterGroup[]>(url, { params: httpParams })
      .pipe(
        map((response) => response.map((filterGroup) => this.filtersSearchFactory.buildSearchFilters(filterGroup)))
      );
  }
}
